
<div class="wrapper wrapper-content container animated fadeInRight">
  <form name="form" class="form-horizontal" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
    <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Bank</h5>
              <!--<iboxtools></iboxtools>-->
            </div>
            <div class="ibox-content" >
              <div class="row">
                <div class="col-lg-6"> 
                  <div class="form-group row">
                    <label for="code" class="col-lg-3 col-form-label">Code </label>
                    <div class="col-lg-9">
                      <input type="text" class="form-control" name="code" [(ngModel)]="obj.code" #code="ngModel" [ngClass]="{ 'is-invalid': f.submitted && code.invalid }" required />
                      <div *ngIf="f.submitted && code.invalid" class="invalid-feedback">
                        <div *ngIf="code.errors.required">Field is required</div>
                      </div>
                    </div>
                  </div>
                      <div class="form-group row">
                        <label for="name" class="col-lg-3 col-form-label">Name</label>
                        <div class="col-lg-9">
                          <input type="text" class="form-control" name="name" [(ngModel)]="obj.name" #name="ngModel" [ngClass]="{ 'is-invalid': f.submitted && name.invalid }" required />
                          <div *ngIf="f.submitted && name.invalid" class="invalid-feedback">
                            <div *ngIf="name.errors.required">Field is required</div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="refCode" class="col-lg-3 col-form-label">Ref Code</label>
                        <div class="col-lg-9">
                          <input type="text" class="form-control" name="refCode" [(ngModel)]="obj.refCode" #refCode="ngModel"     />
                          
                        </div>
                      </div>
                     
 
                </div>
              </div>
            </div>
            <div class="ibox-footer">
              <div class="row">
                <div class="col-lg-12 text-right">
                    <div class="clearfix"></div>                     
                    <button class="btn btn-primary" type="submit">Submit</button>    
                    <a class="btn btn-default" [routerLink]="['/setup/bank']">Cancel</a>                
                  </div>
                </div>
            </div>
          </div>
     </div>   
    </div>  
  </form> 
</div>
